import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="page-load"
export default class extends Controller {
  connect() {
    const event = new Event('page:load');
    document.dispatchEvent(event);
  }
}
